export default __webpack_public_path__ + "static/media/grey-chevron-right.ef805a7e.svg";